<template>
	<transition name="fade">
		<div class="rb-loader" :class="{center, inline}">
			<div class=" sk-folding-cube">
				<div class="sk-cube1 sk-cube"></div>
				<div class="sk-cube2 sk-cube"></div>
				<div class="sk-cube4 sk-cube"></div>
				<div class="sk-cube3 sk-cube"></div>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
		name: 'RbLoader',
		props: {
			center: {
				type: Boolean,
				default: false
			},
			inline: {
				type: Boolean,
				default: false
			},
		},
		data: () => ({}),
	}
</script>

<style lang="scss" scoped>
	.rb-loader {
		pointer-events: none;
		display: inline-block;

		&.center {
			display: block;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
		}

		&.inline {
			display: inline-block;
			height: 10px;
			width: 22px;
			transform: scale(.3) translateY(-407%);
		}
	}

	.sk-folding-cube {
		margin: 20px auto;
		width: 40px;
		height: 40px;
		position: relative;
		transform: rotateZ(45deg);
	}

	$scale: .7;

	.sk-folding-cube .sk-cube {
		float: left;
		width: 50%;
		height: 50%;
		position: relative;
		transform: scale($scale);
	}

	.sk-folding-cube .sk-cube:before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba($highlight, .9);
		animation: sk-foldCubeAngle 2.4s infinite linear both;
		transform-origin: 100% 100%;
		border: 1px solid rgba($primary-2, .9);
		box-shadow: 0 0 8px rgba($primary-2, .9);
		filter: blur(0px);
	}

	.sk-folding-cube .sk-cube2 {
		transform: scale($scale) rotateZ(90deg);
	}

	.sk-folding-cube .sk-cube3 {
		transform: scale($scale) rotateZ(180deg);
	}

	.sk-folding-cube .sk-cube4 {
		transform: scale($scale) rotateZ(270deg);
	}

	.sk-folding-cube .sk-cube2:before {
		animation-delay: 0.3s;
	}

	.sk-folding-cube .sk-cube3:before {
		animation-delay: 0.6s;
	}

	.sk-folding-cube .sk-cube4:before {
		animation-delay: 0.9s;
	}

	@keyframes sk-foldCubeAngle {
		0%, 10% {
			transform: perspective(140px) rotateX(-180deg);
			opacity: 0;
			filter: blur(2px);
		}
		25%, 75% {
			transform: perspective(140px) rotateX(0deg);
			opacity: 1;
			filter: blur(0px);
		}
		90%, 100% {
			transform: perspective(140px) rotateY(180deg);
			opacity: 0;
			filter: blur(2px);
		}
	}
</style>
